import { useState } from 'react';
import {
  IconButton,
} from '@mui/material';
import {
  PlayCircleFilled as PlayCircleFilledIcon,
} from '@mui/icons-material';
import LessonPlay from '../../lessonplay/LessonPlay';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './PlayLessonDetailAction.scss';

/**
 * Play Lesson Action Container
 */
const defaultProps = {
  user: null,
  userProfile: null,
  onLessonFinished: () => { },
  terminologies: {},
};

export default function PlayLessonDetailAction(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { lesson, user, userProfile, onLessonFinished, terminologies } = mergedProps;
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton
        aria-label='Play Lesson'
        className='lesson-detail-panel-play-button'
        onClick={() => { setOpen(true); }}
        data-test='lesson-detail-panel-play-action'
      >
        <PlayCircleFilledIcon className='play-icon' />
      </IconButton>
      {open && (
        <LessonPlay
          open={open}
          handleClose={() => { setOpen(false); }}
          lesson={lesson}
          user={user}
          userProfile={userProfile}
          terminologies={terminologies}
          onLessonFinished={onLessonFinished}
        />
      )}
    </>
  );
}
